import _extends from'@babel/runtime/helpers/extends';import _objectWithoutProperties from'@babel/runtime/helpers/objectWithoutProperties';import React from'react';import PropTypes from'prop-types';import styled from'styled-components';import {typography,useTheme,Checkbox as Checkbox$2}from'@manulife/mux';var Label = /*#__PURE__*/styled.label.withConfig({
  displayName: "Checkbox__Label",
  componentId: "nv0xeb-0"
})(["align-self:center;font-family:", ";font-size:1rem;font-weight:", ";line-height:", ";vertical-align:middle;cursor:", ";color:", ";"], typography.fontFamily, function (_ref) {
  var checked = _ref.checked;
  return checked ? typography.fontWeightNormal : typography.fontWeightLight;
}, typography.lineHeight, function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled ? 'not-allowed' : 'pointer';
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled,
    theme = _ref3.theme;
  return isDisabled ? theme.colorPalette.neutralColors.dark.shade_light_4 : theme.colorPalette.neutralColors.dark.shade_light_1;
});
var Checkbox = function Checkbox(_ref4) {
  var id = _ref4.id,
    label = _ref4.label,
    checked = _ref4.checked,
    onChange = _ref4.onChange,
    disabled = _ref4.disabled,
    rest = _objectWithoutProperties(_ref4, ["id", "label", "checked", "onChange", "disabled"]);
  var theme = useTheme();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox$2, _extends({
    id: id,
    checked: checked,
    onChange: onChange
  }, rest)), /*#__PURE__*/React.createElement(Label, {
    htmlFor: id,
    checked: checked,
    isDisabled: disabled,
    theme: theme
  }, label));
};
process.env.NODE_ENV !== "production" ? Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
} : void 0;
Checkbox.defaultProps = {
  disabled: false
};
var Checkbox$1 = Checkbox;export{Checkbox$1 as default};